<template>
  <div class="page-item">
    <base-section-title class="p-t-24 p-l-24 p-r-24 p-b-8" title="文档资料">
      <template v-slot:right-tool>
        <el-button class="m-r-5 m-t-8" type="text" @click="toJxicDocumentPage">
          查看更多
        </el-button>
      </template>
    </base-section-title>

    <nav-bar
      :list="navList"
      type="card"
      :show-total="false"
      @handleSelect="handleNavChange"
      @handleSelectChild="handleSelectChild"
    />

    <div v-if="list.length" class="content">
      <el-table :data="list" :show-header="false">
        <el-table-column align="left" show-overflow-tooltip width="200px">
          <template v-slot:default="{ row }">
            <span>{{ row.documentName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left">
          <template v-slot:default="{ row }">
            <span>{{ row.releaserEmpName || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left">
          <template v-slot:default="{ row }">
            <span>{{ timeDiffFilter(row.releaseTime) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left">
          <template v-slot:default="{ row }">
            <upload-authorization-file
              :attachment-group-id="row.attachmentIds[0]"
              upload-mode="fileId"
              :preview-api="previewJxicDocumentApi"
              :download-api="downloadJxicDocumentApi"
              :props-data="{
                uploadMode: 'fileId',
                disabled: true,
                fileListHiddenControl: { hiddenFileName: true }
              }"
              :request-params="{
                documentId: row.documentId,
                attachmentId: row.attachmentIds[0],
                isRelease: true
              }"
              :translate-data="{
                downloadTranslate: 'documentFileUrl'
              }"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-empty v-else description="暂无数据" :image="noData" class="content" />
  </div>
</template>

<script>
// 组件
import BaseSectionTitle from '@/components/common/BaseSectionTitle.vue'
import NavBar from '@/views/home/components/NavBar.vue'
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'
// 字典
import {
  jxicDocTypeDict,
  jxicOtherDocTypeDict,
  isDeletedDict
} from '@/dictionary/jxic-document'
// 接口
import {
  downloadJxicDocumentApi,
  getJxicDocumentPageApi,
  previewJxicDocumentApi
} from '@/api/jxic-document'
// 工具函数
import DateUtils from '@/utils/date'
import { mapState } from 'vuex'

/**
 * @description 省投文档资料模块
 */
export default {
  name: 'JxicDocument',
  components: { NavBar, BaseSectionTitle, UploadAuthorizationFile },

  data() {
    return {
      jxicDocTypeDict,
      jxicOtherDocTypeDict,
      isDeletedDict,

      filterForm: {
        // 文档类型
        documentType: jxicDocTypeDict.PLATFORM_NOTICE.value,
        otherInformationType: ''
      },
      activeName: 'PLATFORM_NOTICE',
      list: [],
      total: 0,
      noData: require('@/assets/images/home/Project-no-data.png')
    }
  },

  computed: {
    ...mapState('systemTime', ['staticDate']),
    navList() {
      return jxicDocTypeDict.array.map(item => {
        if (item.value === jxicDocTypeDict.DOCUMENT.value) {
          return {
            navTitle: item.label,
            total: 0,
            value: item.value,
            children: [
              { navTitle: '采购项目资料', value: 4 },
              { navTitle: '其他资料', value: 5 }
            ]
          }
        } else {
          return {
            navTitle: item.label,
            total: 0,
            value: item.value
          }
        }
      })
    }
  },

  created() {
    this.getList()
  },

  methods: {
    downloadJxicDocumentApi,
    previewJxicDocumentApi,
    /**
     * 获取文档资料列表
     */
    getList() {
      this.$store.dispatch('systemTime/getSystemTime')
      const params = {
        page: 1,
        size: 6,
        isDeleted: isDeletedDict.NO.value,
        ...this.filterForm
      }
      getJxicDocumentPageApi(params)
        .then(res => {
          this.list = res.data?.records || []
          this.total = res.data?.total || 5
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    },

    handleClick() {
      if (this.activeName === 'DOCUMENT') {
        this.filterForm.documentType = jxicDocTypeDict[this.activeName].value
      } else {
        this.filterForm.documentType = jxicDocTypeDict[this.activeName].value
        this.filterForm.otherInformationType = ''
      }
    },

    handleNavChange(index, nav) {
      this.filterForm.documentType = nav.value
      if (nav.value !== jxicDocTypeDict.DOCUMENT.value) {
        this.filterForm.otherInformationType = ''
      } else {
        this.filterForm.otherInformationType =
          jxicOtherDocTypeDict.PROJECT.value
      }
      this.getList()
    },

    handleSelectChild(chItem) {
      if (chItem.value === 4) {
        this.filterForm.otherInformationType =
          jxicOtherDocTypeDict.PROJECT.value
      }
      if (chItem.value === 5) {
        this.filterForm.otherInformationType = jxicOtherDocTypeDict.OTHER.value
      }
      this.getList()
    },

    /**
     * 前往省投文档资料页面
     */
    toJxicDocumentPage() {
      let documentType = ''
      if (this.filterForm.documentType == jxicDocTypeDict.DOCUMENT.value) {
        if (
          this.filterForm.otherInformationType ==
          jxicOtherDocTypeDict.PROJECT.value
        ) {
          documentType = 4
        }
        if (
          this.filterForm.otherInformationType ==
          jxicOtherDocTypeDict.OTHER.value
        ) {
          documentType = 5
        }
      } else {
        documentType = this.filterForm.documentType
      }
      this.$router.push({
        name: 'JxicDocument',
        query: {
          documentType: documentType
        }
      })
    },

    timeDiffFilter(time) {
      return DateUtils.getTimeDiff(time, this.staticDate)
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 16px 8px 16px 8px;
  box-sizing: border-box;
  position: relative;
}

.content {
  height: 228px;
  overflow: hidden;
}

.tab-pane {
  background: pink;
  position: relative;
  .button-group {
    position: absolute;
    top: 0;
    left: 0;
    background: red;
    // background: pink;
  }
}

//修改tab样式
.hidden-select-child {
  .card {
    margin-bottom: 0px !important;
  }
}
</style>
